var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mockData as documentEvents } from '@web/lib/demo/data/documentEvents';
import { filterData } from '@web/lib/demo/utils';
import { analyticDocumentActivity } from '@workalizer/shared/services/analyticDocumentActivity';
export var documentActivity = function (input) {
    var data = filterData(__spreadArray([], documentEvents, true), [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        }
    ]);
    var documentActivity = analyticDocumentActivity(data.map(function (alert) { return (__assign(__assign({}, alert), { createdAt: new Date(alert.createdAt), updatedAt: new Date(alert.updatedAt), date: new Date(alert.date), subUserId: null, document: __assign(__assign({}, alert.document), { id: alert.document.id, type: alert.document.type || '', createdAt: new Date(alert.document.createdAt), updatedAt: new Date(alert.document.updatedAt), slugId: alert.document.slugId, workspaceId: alert.document.workspaceId, title: alert.document.title, ownerId: null }) })); }));
    return documentActivity;
};
